import { getCsrfValue } from "~/common/utils/ApiHelper";
import { redirectToUrl } from "~/utils/url/urlUtils";
import { LINEAR_CONFIGURATION_REQUEST_QUOTE_CONFIRMATION_PAGE_URL } from "~/utils/url/staticUrls";
import { resolveApiUrl } from "~/utils/url/urlResolver";

const apiUrl = resolveApiUrl("/requestLinearConfigurationQuote");
export function sendLinearRequestQuote(
  productCode: string,
  configurationCode: string | undefined,
  recipientNote: string,
  currentStepNumber: number,
  designation: string,
): Promise<any> {
  const data = {
    productCode: productCode,
    configurationCode: configurationCode,
    recipientNote: recipientNote,
    currentStepNumber: currentStepNumber,
    designation: designation,
  };
  return fetch(apiUrl, {
    body: JSON.stringify(data),
    cache: "no-cache",
    credentials: "same-origin",
    method: "POST",
    mode: "cors",
    headers: {
      dataType: "json",
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
    redirect: "follow",
  }).then((result) => {
    if (result.ok) {
      redirectToUrl(LINEAR_CONFIGURATION_REQUEST_QUOTE_CONFIRMATION_PAGE_URL);
    } else {
      console.error(`Error sending linear quote request: ${result.status}`);
      throw new Error(result.status + "");
    }
  });
}
